import { ISchema, PaywallComponentProps } from '../@types'
import { mergeDeep } from '@/helpers/utils'

export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			components: {
				PaywallPriceDisclaimer: (): PaywallComponentProps.PriceDisclaimer => ({
					vaultConsent: true,
				}),
				PaywallBillingModal: ({ $t, ctx }): PaywallComponentProps.BillingModal => {
					return {
						selectedProduct: ctx.selectedProduct,
						view: 'inline',
						hideNote: true,
						extraPaypalOptions: {
							buttonType: 'yellow-rect-reversed',
							cta: $t('pages.program.form.apple_pay_cta_label'),
						},
						extraApplePayOptions: {
							cta: $t('pages.program.form.apple_pay_cta_label'),
						},
						oneClickButtonsReversed: true,
					}
				},
			},
		},
	)
